module.exports = __webpack_public_path__ + "static/media/Death.7f657407.png";